module.exports = __webpack_public_path__ + "static/ud_wireframing-190c50f6d1a04f77d178d4fef0b5b6c7.svg";